import * as React from 'react';
import { Box, Typography, TextField, Container, Tabs, Tab, Grid, Card, CardContent, CardActions, Button } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';

export default function Downloads() {
    const [selectedCategory, setSelectedCategory] = React.useState('Todos');
    const [searchTerm, setSearchTerm] = React.useState('');

    const [files, setFiles] = React.useState([]);
    const [categories, setCategories] = React.useState([]);
    React.useEffect(() => {
        const fetchData = async () => {
            const response = await fetch('/downloads/data.json');
            const data = await response.json();
            setFiles(data.files);
            setCategories(data.categories);
        };

        fetchData();
    }, []);

    const handleCategoryChange = (event, newValue) => {
        setSelectedCategory(newValue);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredFiles = files.filter((file) => {
        const inCategory = selectedCategory === 'Todos' || file.category === selectedCategory;
        const matchesSearch = file.name.toLowerCase().includes(searchTerm.toLowerCase()) || file.description.toLowerCase().includes(searchTerm.toLowerCase());
        return inCategory && matchesSearch;
    });

    return (
        <Container maxWidth="lg" sx={{ my: 4 }}>
            <div style={{ height: 60 }}></div>

            <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
                Centro de Descargas
            </Typography>
            <Typography variant="h6" align="center" color="text.secondary">
                Encuentra aquí todos los recursos, manuales y software que necesitas.
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                <TextField label="Buscar archivo..." variant="outlined" value={searchTerm} onChange={handleSearchChange} sx={{ width: '50%' }} />
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
                <Tabs value={selectedCategory} onChange={handleCategoryChange} centered>
                    {categories.map((category) => (
                        <Tab key={category} label={category} value={category} />
                    ))}
                </Tabs>
            </Box>

            <Grid container spacing={4}>
                {filteredFiles.length > 0 ? (
                    filteredFiles.map((file) => (
                        <Grid key={file.id} size={{ xs: 12, sm: 6, md: 3, lg: 3}}>
                            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <CardContent sx={{ flexGrow: 1 }}>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {file.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {file.description}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small" startIcon={<DownloadIcon />} href={file.fileUrl} variant="contained" download>
                                        Descargar
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))
                ) : (
                    <Grid size={12}>
                        <Typography variant="h6" align="center" color="text.secondary" sx={{ mt: 4 }}>
                            No se encontraron archivos que coincidan con tu búsqueda.
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Container>
    );
}